import * as mutationType from "../mutation_types";

const state = {
  drawer: true
};

const getters = {
  drawer: state => state.drawer
};

const actions = {
  setDrawer({ commit }, val) {
    return new Promise(resolve => {
      commit(mutationType.SET_DRAWER, val);
      resolve();
    });
  }
};

const mutations = {
  [mutationType.SET_DRAWER](state, value) {
    state.drawer = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
